module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Bold.62c69756.woff";